import { CreateMessageAppearanceV2, CreateMessageAppearanceV2Variables } from './__generated__/CreateMessageAppearanceV2'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateMessageAppearanceV2($input: CreateMessageAppearanceInputV2!) {
    createMessageAppearance: createMessageAppearanceV2(input: $input) {
      ... on MessageAppearanceV2 {
        id
        attribution
        sentAt
        created
        subscriptionId
        personId
        boardId
        message {
          id
          characters
          text
        }
      }
      ... on MessageAppearanceErrorV2 {
        type
        error
      }
    }
  }
`

export const useCreateMessageAppearance = () => {
  return useMutation<CreateMessageAppearanceV2, CreateMessageAppearanceV2Variables>(MUTATION)
}
